import { createContext, useContext } from "solid-js";

export interface DeeplinkProviderContextInterface {
	routeToDeeplinkOrUrl: (e: MouseEvent) => void;
}

export const DeeplinkContext = createContext<DeeplinkProviderContextInterface>();

export function useDeeplink() {
	const context = useContext(DeeplinkContext);
	if (!context) throw new Error("useDeeplink must be used within a DeeplinkProvider");
	return context;
}
